import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {addEditPatient, delPatient, generatePatientUser, getPatients} from '../../services';
import {IPatient, IPatientFilter, IPatientRes, IPatientState} from "../types/IPatient";
import {AppState} from "./rootReducer";
import {IPurchase} from "../types/IPurchase";
import {IExchange} from "../types/IExchange";

const initialState: IPatientState = {
    status: "idle"
}

export const mostrarPatients = createAsyncThunk(
    'mostrarPatients', async (params:IPatientFilter|undefined, thunkAPI ) => {
        const {patients} = thunkAPI.getState() as AppState;
        let paramsFilter = params || patients.filtered;

        const response = await getPatients(paramsFilter)
        return {data: response.data as IPatientRes, params: response.config.params}
    }
)

export const agregarEditarPatient = createAsyncThunk(
    'Patients/agregarEditar', async (patient: IPatient, thunkAPI) => {
        const response = await addEditPatient(patient);
        // if (response.status === 200 || response.status === 204) {
        //     if(!!patient.id) {
        //         historyHelper.replace('/patients', {patient: {id: patient.id}})
        //     }else if(crearPrestamo){
        //         historyHelper.replace('/crear/prestamo', { patient: { patientId: response.data.id, fullName: patient.nombres + " " + patient.apellidos }})
        //     }
        //     // else (!!patient.id){
        //     //     historyHelper.replace('/patients', { patient: {id:patient.id} })
        //     // }
        // };
        return {data: response.data, edit:!!patient.id};
    }
);
export const mostrarPatientById = createAsyncThunk(
    'mostrarPatientById', async (id:number,thunkAPI) => {
        // let byId = (thunkAPI.getState() as AppState)?.patients?.list?.items?.find(c=>c.id === id);
        // if(byId){
        //     return {data: byId}
        // }

        const response = await getPatients(id);
        return {data: response.data as IPatient}
    }
)

export const eliminarPatient = createAsyncThunk(
    'patient/eliminar', async (id: number) => {
        await delPatient(id);
        // if (response.status === 200 || response.status === 204) historyHelper.back();
        return id;
    }
);

export const generarUsuarioPatient = createAsyncThunk(
    'patient/generarUsuario', async (id: number) => {
        const response = await generatePatientUser(id);
        // if (response.status === 200 || response.status === 204) {
        //     historyHelper.push(historyHelper.location.pathname,response.data);
        // }

        return {data: response.data};
    }
);


const slice = createSlice({
    name: 'mostrarPatients',
    initialState,
    reducers: {
        updatePurchaseItem(state,action: PayloadAction<IPurchase>) {
            let purchases = state.byId?.purchases?.map(item=>{
                if(item.id === action.payload.id){
                    return {...item, ...action.payload};
                }
                return item;
            })

            state.byId = {...state.byId, purchases };
        },
        updateExchangeItem(state,action: PayloadAction<IExchange>) {
            let exchanges = state.byId?.exchanges?.map(item=>{
                if(item.id === action.payload.id){
                    return {...item, ...action.payload};
                }
                return item;
            })

            state.byId = {...state.byId, exchanges };
        },
    },
    extraReducers: builder => {
        //--mostrarPatients
        builder.addCase(mostrarPatients.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarPatients.fulfilled, (state,action ) => {
            state.status = "idle";
            state.filtered = action.payload.params;
            state.list = action.payload.data;
        })
        builder.addCase(mostrarPatients.rejected, (state ) => {
            state.status = "idle";
        })

        //--agregarEditarPatient
        builder.addCase(agregarEditarPatient.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(agregarEditarPatient.fulfilled, (state,action ) => {
            state.status = "idle";
            if(state.list){
                state.list.items = state.list?.items.filter(e => e.id !== action.payload.data.id);
                state.list.items.unshift(action.payload.data);
                if(!action.payload.edit){
                    ++state.list.pageSize
                    ++state.list.totalCount
                }

            }
        })
        builder.addCase(agregarEditarPatient.rejected, (state ) => {
            state.status = "idle";
        })
        //--mostrarPatientById
        builder.addCase(mostrarPatientById.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarPatientById.fulfilled, (state,action ) => {
            state.status = "idle";
            state.byId = action.payload.data;
        })
        builder.addCase(mostrarPatientById.rejected, (state ) => {
            state.status = "idle";
        })

        //--eliminarPatient
        builder.addCase(eliminarPatient.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(eliminarPatient.fulfilled, (state,action ) => {
            state.status = "idle";
            const id = action.payload;
            if(state.list?.items){
                state.list.items = state.list?.items.filter(e => e.id !== id)
            }
        })
        builder.addCase(eliminarPatient.rejected, (state ) => {
            state.status = "idle";
        })
        //--generar Usuario
        builder.addCase(generarUsuarioPatient.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(generarUsuarioPatient.fulfilled, (state,action ) => {
            state.status = "idle";
            state.byId = {...state.byId, userId:action.payload.data.id}
        })
        builder.addCase(generarUsuarioPatient.rejected, (state ) => {
            state.status = "idle";
        })
    }
});

export const {updatePurchaseItem, updateExchangeItem} = slice.actions;
export default slice.reducer;
